import {StyleSheet} from "aphrodite";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body, HeadingMedium} from "@khanacademy/wonder-blocks-typography";

import noChatsImage from "../images/no_chats_yet@2x.png";

interface Props {
    // The main title text to display
    title: string;
    // The subtitle/description text to display
    subtitle: string;
    // Optional href for the CTA button
    href?: string;
    // Optional text for the CTA button (defaults to "Get started")
    buttonText?: string;
    // Whether to show the CTA button (defaults to true if href is provided)
    showButton?: boolean;
}

/**
 * A reusable empty state component that displays an image, title, subtitle, and optional CTA button.
 */
export function EmptyState({
    title,
    subtitle,
    href,
    buttonText = "Get started",
    showButton,
}: Props): React.ReactElement {
    const shouldShowButton = showButton ?? href != null;

    return (
        <View style={styles.emptyState}>
            <img src={noChatsImage} alt="" width={175} height={100} />
            <HeadingMedium>{title}</HeadingMedium>
            <Body>{subtitle}</Body>
            {shouldShowButton && href && (
                <Button kind="secondary" href={href}>
                    {buttonText}
                </Button>
            )}
        </View>
    );
}

const styles = StyleSheet.create({
    emptyState: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: spacing.xLarge_32,
        textAlign: "center",
        gap: spacing.medium_16,
    },
});
